import React from 'react';
import moment from 'moment';

const FullScreenHeader = ({ session }) => {
    const formattedDate = session
        ? moment(session.date).format('dddd, MMMM D')
        : null;

    return (
        <div className="fullscreen-header">
            <div className="fullscreen-header-left">
                <img
                    className="fullscreen-header-th-logo"
                    alt="TrainHeroic"
                    src="https://static.trainheroic.com/images/h_white.png"
                />
            </div>
            {session && (
                <div className="fullscreen-header-center">
                    {formattedDate && (
                        <span className="fullscreen-header-date">
                            {formattedDate}
                        </span>
                    )}
                    {session.title && (
                        <span className="fullscreen-header-title">
                            {session.title}
                        </span>
                    )}
                </div>
            )}
            <div className="fullscreen-header-right" />
        </div>
    );
};

export default FullScreenHeader;



// WEBPACK FOOTER //
// ./src/view/fullScreenWorkout/FullScreenHeader.jsx